import styled from "styled-components";

export const ServiceContainer = styled.div`
  display: flex;
  position: relative;
  margin-top: -5rem;
  min-height: 100px;
  padding: 1rem;
  height: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 3px;

  @media screen and (max-width: 786px) {
    margin-top: 0rem;
  }
`;
export const BorderBg = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #1c0824;
  color: #fff;
  border-radius: 5px;
`;

export const ServesBg = styled.div`
  position: relative;
  display: grid;
  border-radius: 5px;
  border: 1px solid #fff;
  justify-content: space-between;
  align-items: center;
  grid-template-columns: repeat(6, 1fr);

  @media screen and (max-width: 786px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 500px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 400px) {
    grid-template-columns: 1fr;
  }
`;
export const ServiceContent = styled.div`
  position: relative;

  text-align: center;
  justify-content: center;
  align-items: center;
  min-height: 100px;
  min-width: 100px;
  margin: 1rem;
  @media screen and (max-width: 786) {
    margin: 0;
    min-height: 80px;
    min-width: 80px;
  }
  /* box-shadow: 0px 1px 1px 0px #5e0087;  */
`;

export const ServiceIcon = styled.div`
  position: relative;

  text-align: center;
  align-items: center;
  justify-content: center;
  /* padding: 22.4px; */
  font-size: 100px;
  min-height: 100px;
  min-width: 100px;
  @media screen and (max-width: 786) {
    margin: 0;
    min-height: 80px;
    min-width: 80px;
  }
`;
export const ServiceTitle = styled.p`
  position: relative;

  text-align: center;
  justify-content: center;
  align-items: center;
  /* padding: 1px; */
  font-size: 14px;
  letter-spacing: 2px;
  display: flex;
  white-space: pre-line;
`;
